import React, { useEffect, useState } from "react";
import "./hot.css";
import classNames from "classnames";
import axios from "axios";

export default function Hot() {
  // 导航栏默认选项
  const [watch, setWatch] = useState(1);
  // 导航栏数据
  const hotmenu = [
    { id: 1, msg: "热搜" },
    { id: 2, msg: "国内" },
    { id: 3, msg: "国际" },
    { id: 4, msg: "" },
    { id: 5, msg: "" },
  ];

  useEffect(() => {}, [watch]);

  const [enter, setEnter] = useState(false);
  // 记录显示第几张轮播图
  const [num, setNum] = useState(10);
  // 鼠标移入移出
  useEffect(() => {}, [enter]);
  // 显示第几张轮播图
  useEffect(() => {}, [num]);

  const [tou, setTou] = useState([]);
  useEffect(() => {
    axios.get("http://www.itemev.com/home/Toutiao").then((response) => {
      setTou(response.data);
    });
  }, []);

  // 国内
  const [nei, setNei] = useState([]);
  const [neilun, setNeilun] = useState(10);

  // 国外
  const [wai, setWai] = useState([]);
  const [wailun, setWailun] = useState(10);

  return (
    <div className="hot">
      {/* 导航栏 */}
      <div className="hot-menu">
        {hotmenu.map((item) => {
          return (
            //   导航栏选项
            <div className="hot-menulist" key={item.id}>
              {/* 顶部小绿块 */}
              {item.id === watch && <div className="hot-br"></div>}

              <span
                onClick={() => {
                  if (item.id === 2) {
                    axios
                      .get("http://www.itemev.com/home/Guonei")
                      .then((response) => {
                        setNei(response.data);
                      });
                  }
                  if (item.id === 3) {
                    axios
                      .get("http://www.itemev.com/home/Guoji")
                      .then((response) => {
                        setWai(response.data);
                      });
                  }
                  setWatch(item.id);
                }}
                className={classNames({ "color-green": item.id === watch })}
              >
                {item.msg}
              </span>
            </div>
          );
        })}
      </div>

      {/* 轮播图 */}
      {watch === 1 && (
        <>
          <div
            className="hot-swiper"
            onMouseEnter={() => {
              setEnter(true);
            }}
            onMouseLeave={() => {
              setEnter(false);
            }}
          >
            {/* 遍历数据 */}
            {tou !== [] && (
              <>
                {tou.slice(num, num + 1).map((list) => {
                  return (
                    <div key={list.uniquekey} className="hot-width">
                      {list.thumbnail_pic_s === "" && (
                        <img
                          src={require("../Movie/img/none.jpg")}
                          alt=""
                          className="hot-swiper-img"
                          onClick={() => {
                            window.open(list.url);
                          }}
                        />
                      )}
                      {list.thumbnail_pic_s !== "" && (
                        <img
                          src={list.thumbnail_pic_s}
                          alt=""
                          className="hot-swiper-img"
                          onClick={() => {
                            window.open(list.url);
                          }}
                        />
                      )}

                      <div className="hot-swiper-title">
                        <span
                          onClick={() => {
                            window.open(list.url);
                          }}
                        >
                          {list.title}
                        </span>
                      </div>

                      {/* 轮播图往前 */}
                      {enter === true && (
                        <>
                          <div
                            className="hot-swiper-left"
                            onClick={() => {
                              setNum(num - 1);
                              if (num === 9) {
                                setNum(12);
                              }
                            }}
                          >
                            <span>{"<"}</span>
                          </div>
                          {/* 轮播图往后 */}
                          <div
                            className="hot-swiper-right"
                            onClick={() => {
                              setNum(num + 1);
                              if (num === 12) {
                                setNum(9);
                              }
                            }}
                          >
                            <span>{">"}</span>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </>
            )}
          </div>
          {/* 新闻列表 */}
          <div className="hot-news">
            {tou !== [] && (
              <>
                {tou.slice(0, 7).map((todo) => {
                  return (
                    <div className="hot-newslist" key={todo.uniquekey}>
                      <span
                        onClick={() => {
                          window.open(todo.url);
                        }}
                      >
                        {todo.title}
                      </span>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </>
      )}

      {watch === 2 && (
        <>
          <div
            className="hot-swiper"
            onMouseEnter={() => {
              setEnter(true);
            }}
            onMouseLeave={() => {
              setEnter(false);
            }}
          >
            {/* 遍历数据 */}
            {nei !== [] && (
              <>
                {nei.slice(neilun, neilun + 1).map((list) => {
                  return (
                    <div key={list.uniquekey}>
                      {list.thumbnail_pic_s === "" && (
                        <img
                          src={require("../Movie/img/none.jpg")}
                          alt=""
                          className="hot-swiper-img"
                          onClick={() => {
                            window.open(list.url);
                          }}
                        />
                      )}
                      {list.thumbnail_pic_s !== "" && (
                        <img
                          src={list.thumbnail_pic_s}
                          alt=""
                          className="hot-swiper-img"
                          onClick={() => {
                            window.open(list.url);
                          }}
                        />
                      )}

                      <div className="hot-swiper-title">
                        <span
                          onClick={() => {
                            window.open(list.url);
                          }}
                        >
                          {list.title}
                        </span>
                      </div>

                      {/* 轮播图往前 */}
                      {enter === true && (
                        <>
                          <div
                            className="hot-swiper-left"
                            onClick={() => {
                              setNeilun(neilun - 1);
                              if (neilun === 9) {
                                setNeilun(12);
                              }
                            }}
                          >
                            <span>{"<"}</span>
                          </div>
                          {/* 轮播图往后 */}
                          <div
                            className="hot-swiper-right"
                            onClick={() => {
                              setNeilun(neilun + 1);
                              if (neilun === 12) {
                                setNeilun(9);
                              }
                            }}
                          >
                            <span>{">"}</span>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </>
            )}
          </div>
          {/* 新闻列表 */}
          <div className="hot-news">
            {nei !== [] && (
              <>
                {nei.slice(0, 7).map((todo) => {
                  return (
                    <div className="hot-newslist" key={todo.uniquekey}>
                      <span
                        onClick={() => {
                          window.open(todo.url);
                        }}
                      >
                        {todo.title}
                      </span>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </>
      )}

      {watch === 3 && (
        <>
          <div
            className="hot-swiper"
            onMouseEnter={() => {
              setEnter(true);
            }}
            onMouseLeave={() => {
              setEnter(false);
            }}
          >
            {/* 遍历数据 */}
            {wai !== [] && (
              <>
                {wai.slice(wailun, wailun + 1).map((list) => {
                  return (
                    <div key={list.uniquekey}>
                      {list.thumbnail_pic_s === "" && (
                        <img
                          src={require("../Movie/img/none.jpg")}
                          alt=""
                          className="hot-swiper-img"
                          onClick={() => {
                            window.open(list.url);
                          }}
                        />
                      )}
                      {list.thumbnail_pic_s !== "" && (
                        <img
                          src={list.thumbnail_pic_s}
                          alt=""
                          className="hot-swiper-img"
                          onClick={() => {
                            window.open(list.url);
                          }}
                        />
                      )}

                      <div className="hot-swiper-title">
                        <span
                          onClick={() => {
                            window.open(list.url);
                          }}
                        >
                          {list.title}
                        </span>
                      </div>

                      {/* 轮播图往前 */}
                      {enter === true && (
                        <>
                          <div
                            className="hot-swiper-left"
                            onClick={() => {
                              setWailun(wailun - 1);
                              if (wailun === 9) {
                                setWailun(12);
                              }
                            }}
                          >
                            <span>{"<"}</span>
                          </div>
                          {/* 轮播图往后 */}
                          <div
                            className="hot-swiper-right"
                            onClick={() => {
                              setWailun(wailun + 1);
                              if (wailun === 12) {
                                setWailun(9);
                              }
                            }}
                          >
                            <span>{">"}</span>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </>
            )}
          </div>
          {/* 新闻列表 */}
          <div className="hot-news">
            {wai !== [] && (
              <>
                {wai.slice(0, 7).map((todo) => {
                  return (
                    <div className="hot-newslist" key={todo.uniquekey}>
                      <span
                        onClick={() => {
                          window.open(todo.url);
                        }}
                      >
                        {todo.title}
                      </span>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
